module.exports = __webpack_public_path__ + "img/lei_comentada_gg.bb7ab27f.png";